module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-200.woff?9a8c9e04f07848cbcc91831851df2001";